import { CheckCircleTwoTone } from "@ant-design/icons";
import Typography from "@mui/material/Typography";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import Button from "@mui/material/Button";
import { numberRegex } from "Admin/Utils/numberRegex";
import { Tag, Tooltip } from "antd";
import styles from "./ProfilePublication.module.scss";
const ProfilePublication = ({ publication }) => {
  const checkedCircleColor =
    publication.verified === true ? "#52c41a" : "lightgray";
  const toolTipText =
    publication.verified === true ? "Verified" : "Not yet verified";

  return (
    <div className={styles["profile-publication"]}>
      <div className={styles["title"]}>
        <span>
          <Tooltip title={toolTipText}>
            <CheckCircleTwoTone twoToneColor={checkedCircleColor} />
          </Tooltip>
          &nbsp;
        </span>
        <span className={styles["paper-title"]}>
          <a href={publication.doi} target="_blank">
            {publication.title}.{" "}
          </a>
        </span>
        <span className={styles["venue"]}>
          <i>{publication.venue} </i>
        </span>
        <span>{publication.year > 0 ? `(${publication.year})` : ""}</span>
      </div>
      <div className={styles["coauthors"]}>
        {publication.authors?.map((item, index) => {
          return <span key={index}>{item.name}</span>;
        })}
      </div>
      <div className={styles["tags"]}>
        {publication.keywords?.map((item, index) => {
          return <Tag key={index}>{item.value}</Tag>;
        })}
      </div>
      <div className={styles["action"]}>
        {publication.citation_count != 0 && (
          <Button
            style={{
              backgroundColor: "white",
              color: "#b45f06",
              borderRadius: 10,
              height: 25,
              paddingLeft: 0,
              textAlign: "left",
              textTransform: "none",
              marginRight: "10px",
            }}
          >
            <FormatQuoteIcon />
            <Typography align={"left"} style={{ fontSize: 12 }}>
              {numberRegex(parseFloat(publication["citation_count"]))}
            </Typography>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProfilePublication;
